






















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import DataUtility from "@/services/DataUtility";
import { storePerawat } from "@/store/modules/perawat";

@Component({
  components: {}
})
export default class PerawatAutoComplete extends Vue {
  @Prop() setPerawat!: object | string | number;
  @Prop({ default: null }) label?: string;
  @Prop({ default: true }) required!: boolean;
  perawat = {};
  // listPerawat = [];
  list = [];
  searchPerawat = null;
  _timerId;
  loading = false;

  get validasi() {
    return this.required ? [v => !!v || "*Kolom Perawat Harus Diisi"] : [];
  }

  // @Watch("perawat")
  // changeTd(val) {
  //   this.$emit("perawat", val);
  // }

  // @Watch("setPerawat")
  // valDarah(val) {
  //   // this.perawat = val;
  //   this.$emit("perawat", val);
  // }

  get valPerawat() {
    if (typeof this.setPerawat == "object") {
      return this.setPerawat;
    } else {
      return this.listPerawat.find(it => it.id == this.setPerawat);
    }
  }
  set valPerawat(val) {
    this.$emit("perawat", val);
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  // mounted() {
  //   const dt = DataUtility.getListPerawat();
  //   dt.then((dt) => {
  //     // this.list = dt.data;
  //     this.listPerawat = dt.data;
  //   });
  // }

  // @Watch("searchPerawat", { deep: true })
  // searchedPerawat() {
  //   if (
  //     this.searchPerawat === null ||
  //     this.searchPerawat.length < 2 ||
  //     this.perawat === this.searchPerawat
  //   ) {
  //     this.listPerawat = [];
  //   } else {
  //     this.listPerawat = this.list;
  //   }
  // }

  // @Watch("searchPerawat", { deep: true })
  // searchedPerawat() {
  //   this.listPerawat = [];
  //   clearTimeout(this._timerId);
  //   this._timerId = setTimeout(() => {
  //     if (
  //       this.searchPerawat === null ||
  //       this.searchPerawat.length < 2 ||
  //       this.perawat === this.searchPerawat
  //     )
  //       return;
  //     this.loading = true;
  //     const dt = DataUtility.getDataPerawatAutoComplete(this.searchPerawat);
  //     dt.then((dt) => {
  //       this.listPerawat = dt.map((perawat) => {
  //         return perawat;
  //       });
  //       if (!dt.length) {
  //         this.perawat = this.searchPerawat;
  //       }
  //     })
  //       .catch((err) => {
  //         console.log(err);
  //       })
  //       .finally(() => (this.loading = false));
  //   }, 500);
  // }
}
